import ListItem from "@mui/material/ListItem"
import { Conversation } from "../../interface/Conversation"
import Card from "@mui/material/Card"
import ListItemAvatar from "@mui/material/ListItemAvatar"
import Avatar from "@mui/material/Avatar"
import ListItemText from "@mui/material/ListItemText"
import Typography from "@mui/material/Typography"
import Box from "@mui/material/Box"
import moment from "moment"
import { blue, green } from "@mui/material/colors"
import { useGravatar } from '../modals/UserDetails/hooks/useGravatar';
import { alpha, useTheme } from "@mui/material/styles"

interface MessageCardProps
{
  message: Conversation
}

export const MessageCard = ({ message }: MessageCardProps) => {
  const theme = useTheme()
  const isAdmin = !!message.isAdmin

  const { gravatarImage } = useGravatar(100, message.from)

  return (
    <Box sx={localStyles.row(isAdmin)}>
      <Card sx={localStyles.card(theme, isAdmin)} >
        <ListItem sx={localStyles.item}>
          <ListItemAvatar>
            <Avatar sx={localStyles.avatar(isAdmin)} src={gravatarImage} >
              {message.from[0].toUpperCase() + message.from[1].toUpperCase()}
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary={message.from}
            secondary={message.message}
            primaryTypographyProps={{ fontWeight: "700" }}
            secondaryTypographyProps={{ sx: { color: theme.palette.text.primary, opacity: 0.86 } }}
          />
        </ListItem>

        <Box sx={localStyles.footer}>
          <Typography variant="caption" color="textSecondary">{moment(message.timestamp).fromNow()}</Typography>
        </Box>
      </Card>
    </Box>
  )
}


const localStyles = {
  row: (isAdmin: boolean) => ({
    display: "flex",
    justifyContent: isAdmin ? "flex-end" : "flex-start",
    width: "100%",
    marginTop: 1,
    marginBottom: 1,
  }),
  card: (theme: any, isAdmin: boolean) => ({
    padding: 2,
    width: "min(100%, 520px)",
    borderRadius: "16px",
    border: `1px solid ${isAdmin ? alpha(theme.palette.info.main, 0.26) : alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.08 : 0.35)}`,
    background:
      isAdmin
        ? alpha(theme.palette.info.main, theme.palette.mode === "dark" ? 0.1 : 0.08)
        : alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.03 : 0.64),
    boxShadow: "none",
  }),
  item: {
    alignItems: "flex-start",
    padding: 1,
  },
  avatar: (isAdmin: boolean) => ({
    backgroundColor: isAdmin ? blue[500] : green[500],
  }),
  footer: {
    justifyContent: "flex-end",
    display: 'flex' as 'flex',
    paddingLeft: 2,
    paddingRight: 2,
    paddingBottom: 1,
  }
}
